import { Routes, Route } from "react-router-dom";
import { Intake } from "./routes/Intake.js";
import { SignIn } from "./routes/SignIn.js";
import { ConfirmSignUp } from "./routes/ConfirmSignUp.js";
import { AppShell } from "./routes/AppShell.js";
import { AppHome } from "./routes/AppHome.js";
import { AppRfqs } from "./routes/AppRfqs.js";
import { NewRfq } from "./routes/NewRfq.js";
import { RfqDetail } from "./routes/RfqDetail.js";
import { RfqFeedback } from "./routes/RfqFeedback.js";
import { RfqSubmitted } from "./routes/RfqSubmitted.js";
import { VerifyEmail } from "./routes/VerifyEmail.js";
import { AppAccount } from "./routes/AppAccount.js";
import { AppProperties } from "./routes/AppProperties.js";
import { NewProperty } from "./routes/NewProperty.js";
import { PropertyDetail } from "./routes/PropertyDetail.js";
import { BinderNew } from "./routes/BinderNew.js";
import { BinderEntryDetail } from "./routes/BinderEntryDetail.js";
import { BinderEntryEdit } from "./routes/BinderEntryEdit.js";
import { DebugHealth } from "./routes/DebugHealth.js";
import { AdminShell } from "./routes/AdminShell.js";
import { AdminRfqs } from "./routes/AdminRfqs.js";
import { AdminRfqDetail } from "./routes/AdminRfqDetail.js";
import { ContractorIntake } from "./routes/ContractorIntake.js";
import { ContractorSubmissionsReview } from "./routes/ContractorSubmissionsReview.js";
import { ProtectedRoute } from "./auth/ProtectedRoute.js";
import { ErrorPage } from "./ui/ErrorPage.js";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Intake />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/confirm" element={<ConfirmSignUp />} />
      <Route path="/contractor-intake" element={<ContractorIntake />} />
      <Route path="/contractor-submissions" element={<ContractorSubmissionsReview />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<AppHome />} />
        <Route path="verify-email" element={<VerifyEmail />} />
        <Route path="properties" element={<AppProperties />} />
        <Route path="properties/new" element={<NewProperty />} />
        <Route path="rfqs/new" element={<NewRfq />} />
        <Route path="rfqs/:id/submitted" element={<RfqSubmitted />} />
        <Route path="rfqs/:id" element={<RfqDetail />} />
        {/* Two paths, one form. The :preset segment carries the one-tap answer
            from the feedback email; it must be a path segment, not a query,
            to survive the sign-in redirect. */}
        <Route path="rfqs/:id/feedback" element={<RfqFeedback />} />
        <Route path="rfqs/:id/feedback/:preset" element={<RfqFeedback />} />
        <Route path="properties/:id" element={<PropertyDetail />} />
        <Route path="properties/:id/binder/new" element={<BinderNew />} />
        <Route path="properties/:id/binder/:entryId" element={<BinderEntryDetail />} />
        <Route path="properties/:id/binder/:entryId/edit" element={<BinderEntryEdit />} />
        <Route path="rfqs" element={<AppRfqs />} />
        <Route path="debug/health" element={<DebugHealth />} />
        <Route path="account" element={<AppAccount />} />
      </Route>
      {/*
        Admin RFQ dashboard. Hidden from normal app navigation; reachable
        only by typing /admin or following an out-of-band link. The server
        rejects every admin route for non-admins, so the route shell only
        guards the UI from showing broken affordances.
      */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminRfqs />} />
        <Route path="rfqs/:customerSub/:id" element={<AdminRfqDetail />} />
      </Route>
      <Route
        path="*"
        element={
          <ErrorPage
            status={404}
            title="Page not found"
            detail="The page you tried to open doesn’t exist."
          />
        }
      />
    </Routes>
  );
}
